<template>
  <v-menu v-model="menu" open-on-hover>
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="stockDistrictsSelected"
        clearable
        chips
        multiple
        deletable-chips
        small-chips
        :items="stockDistrictsSelected"
        :loading="stockDistrictsLoading"
        :search-input.sync="stockDistrictsSearch"
        item-text="name"
        item-value="id"
        :label="$t('StockDistrict.title')"
        return-object
        v-bind="attrs"
        v-on="on"
      >
        <template v-slot:append>
          <v-icon
            style="height: 24px; width: 24px"
            :color="menu ? 'primary' : ''"
            @click.stop="menu = !menu"
          >
            {{ menu ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </template>
      </v-autocomplete>
    </template>
    <div style="max-height: 304px">
      <v-sheet>
        <v-treeview
          v-model="stockDistrictsSelected"
          :items="stockDistricts"
          :search="stockDistrictsSearch"
          :filter="districtsFilter"
          selection-type="independent"
          item-key="id"
          item-text="name"
          item-children="stock_districts"
          open-all
          selectable
          selected-color="primary"
          hoverable
          return-object
        />
      </v-sheet>
    </div>
  </v-menu>
</template>

<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>

<script>
import StockDistricts from "@/api/stock_districts";

export default {
  name: "SearcherStockDistricts",

  props: ["value"],

  computed: {
    districtsFilter() {
      return (item, search, textKey) => item[textKey].indexOf(search) > -1;
    },
  },

  created() {
    this.getStockDistrictsFromAPI();
  },

  data: () => ({
    menu: false,
    materialCategories: [],
    materialCategoriesLoading: false,
    materialCategoriesSearch: "",
    materialCategoriesSelected: [],
    
    stockDistricts: [],
    stockDistrictsLoading: false,
    stockDistrictsSearch: "",
    stockDistrictsSelected: [],
  }),

  methods: {
    getStockDistrictsFromAPI() {
      this.stockDistrictsLoading = true;
      StockDistricts.tree()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stockDistricts = response.data.stock_districts;
            }
            this.stockDistrictsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.stockDistrictsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stockDistrictsSelected = this.value ? this.value : [];
      },
    },
    stockDistrictsSelected: {
      handler() {
        this.$emit("input", this.stockDistrictsSelected);
      },
    },
  },
};
</script>
